(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('astreinte-planifie', {
            parent: 'technicienMenu',
            url: '/astreinte-planifie?page&sort&search&technicien&year&month',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'tmgApp.astreintePlanifie.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/astreinte-planifie/astreinte-planifies.html',
                    controller: 'AstreintePlanifieController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                technicien: null,
                year:null,
                month:null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        technicien: $stateParams.technicien,
                        year: $stateParams.year,
                        month: $stateParams.month,
                        search: $stateParams.search,
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('astreintePlanifie');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('astreinte-planifie-detail', {
            parent: 'astreinte-planifie',
            url: '/astreinte-planifie/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'tmgApp.astreintePlanifie.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/astreinte-planifie/astreinte-planifie-detail.html',
                    controller: 'AstreintePlanifieDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('astreintePlanifie');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AstreintePlanifie', function($stateParams, AstreintePlanifie) {
                    return AstreintePlanifie.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'astreinte-planifie',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('astreinte-planifie-detail.edit', {
            parent: 'astreinte-planifie-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/astreinte-planifie/astreinte-planifie-dialog.html',
                    controller: 'AstreintePlanifieDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AstreintePlanifie', function(AstreintePlanifie) {
                            return AstreintePlanifie.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('astreinte-planifie-detail.asknotwork', {
            parent: 'astreinte-planifie-detail',
            url: '/asknotwork',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/astreinte-planifie/astreinte-planifie-notWork.html',
                    controller: 'AstreintePlanifieNotWorkController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AstreintePlanifie', function(AstreintePlanifie) {
                            return AstreintePlanifie.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('astreinte-planifie.new', {
            parent: 'astreinte-planifie',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/astreinte-planifie/astreinte-planifie-dialog.html',
                    controller: 'AstreintePlanifieDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                technicien: null,
                                date: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('astreinte-planifie', null, { reload: 'astreinte-planifie' });
                }, function() {
                    $state.go('astreinte-planifie');
                });
            }]
        })
        .state('astreinte-planifie.newMultiple', {
            parent: 'astreinte-planifie',
            url: '/newMultiple',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/astreinte-planifie/astreinte-planifie-dialogue-multiple.html',
                    controller: 'AstreintePlanifieDialogMultipleController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                technicien: null,
                                date: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('astreinte-planifie', null, { reload: 'astreinte-planifie' });
                }, function() {
                    $state.go('astreinte-planifie');
                });
            }]
        })
        .state('astreinte-planifie.edit', {
            parent: 'astreinte-planifie',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/astreinte-planifie/astreinte-planifie-dialog.html',
                    controller: 'AstreintePlanifieDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AstreintePlanifie', function(AstreintePlanifie) {
                            return AstreintePlanifie.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('astreinte-planifie', null, { reload: 'astreinte-planifie' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('astreinte-planifie.delete', {
            parent: 'astreinte-planifie',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/astreinte-planifie/astreinte-planifie-delete-dialog.html',
                    controller: 'AstreintePlanifieDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AstreintePlanifie', function(AstreintePlanifie) {
                            return AstreintePlanifie.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('astreinte-planifie', null, { reload: 'astreinte-planifie' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
